import { useState } from 'react';
import dayjs, { type Dayjs } from 'dayjs';
import { useMutation } from '@tanstack/react-query';
import { Box, Button, CircularProgress, Paper, Stack, TextField, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { getTicketSalesReport } from '../../../api/endpoints/salesReports';
import { salesReportRows } from '../../../api/types/salesReports';
import { ApiErrorAlert } from '../../../components/ApiErrorAlert';
import { DynamicReportTable } from '../../../components/report/DynamicReportTable';
import { SalesReportTotals } from '../../../components/report/SalesReportTotals';

/** "Bilet Satış Raporu" (legacy `Report/Ticket` + `Report/TicketJson`). */
export default function TicketSalesReportPage() {
  const [start, setStart] = useState<Dayjs | null>(dayjs().startOf('month'));
  const [end, setEnd] = useState<Dayjs | null>(dayjs());
  const [provider, setProvider] = useState('');
  const [username, setUsername] = useState('');

  const report = useMutation({
    mutationFn: () =>
      getTicketSalesReport({
        startDate: (start ?? dayjs()).format('YYYY-MM-DD'),
        endDate: (end ?? dayjs()).format('YYYY-MM-DD'),
        status: 'Booked',
        providerType: 'Air',
        provider: provider || undefined,
        username: username || undefined,
      }),
  });

  const rows = salesReportRows(report.data);

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Bilet Satış Raporu
      </Typography>

      <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} sx={{ flexWrap: 'wrap' }}>
          <DatePicker label="Başlangıç" value={start} onChange={setStart} slotProps={{ textField: { size: 'small' } }} />
          <DatePicker label="Bitiş" value={end} onChange={setEnd} slotProps={{ textField: { size: 'small' } }} />
          <TextField
            size="small"
            label="Sağlayıcı"
            value={provider}
            onChange={(e) => setProvider(e.target.value)}
          />
          <TextField
            size="small"
            label="Kullanıcı"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <Button variant="contained" onClick={() => report.mutate()} disabled={report.isPending}>
            {report.isPending ? 'Getiriliyor…' : 'Raporu Getir'}
          </Button>
        </Stack>
        <ApiErrorAlert error={report.error} sx={{ mt: 2 }} />
      </Paper>

      {report.isPending && <CircularProgress size={24} />}
      {report.isSuccess && (
        <>
          <SalesReportTotals data={report.data} />
          <DynamicReportTable rows={rows} fileName="bilet-satis-raporu" />
        </>
      )}
    </Box>
  );
}
